import {
    FETCHED_STAFF,
    FETCHED_STAFF_MEMBER,
    CREATED_STAFF_MEMBER,
    UPDATED_STAFF_MEMBER,
    DISABLED_STAFF_MEMBER,
    ENABLED_STAFF_MEMBER,
    FETCHED_STAFF_TITLES,
    FETCHED_JOB_TITLES,
    FETCHED_STAFF_SITES,
    FETCHED_STAFF_TEAMS,
    FETCHED_PROJECTS_BY_DESTINATION,
    SELECT_STAFF_TITLE,
    SELECT_JOB_TITLES,
    SELECT_STAFF_NAME,
    SELECT_STAFF_FIRST_NAME,
    SELECT_STAFF_TEAMS,
    SELECT_STAFF_SITES,
    SELECT_STAFF_DESTINATIONS,
    SELECT_STAFF_DESCRIPTION,
    PROJECT_REMOVE_FOR_DESTINATION,
    PROJECT_ADD_FOR_DESTINATION,
    FETCHED_STAFF_TRANSLATION,
    FETCHED_STAFF_TRANSLATIONS,
    CREATED_STAFF_TRANSLATION,
    UPDATED_STAFF_TRANSLATION,
    DELETED_STAFF_TRANSLATION,
    ADD_IMAGE,
    DELETE_IMAGE,
    UPDATE_CROPPED_IMAGE,
    UPDATE_IMAGE_META,
    DELETED_STAFF,
} from './types';

export function fetchedStaff(data, totalPages) {
    return {
        type: FETCHED_STAFF,
        payload: {
            data: data,
            totalPages: totalPages,
        },
    };
}

export function fetchedJobTitles(jobs) {
    return {
        type: FETCHED_JOB_TITLES,
        jobs,
    };
}

export function fetchedStaffSites(sites) {
    return {
        type: FETCHED_STAFF_SITES,
        sites,
    };
}

export function createdStaff(response) {
    return {
        type: CREATED_STAFF_MEMBER,
        response,
    };
}

export function updatedStaff(staffMember) {
    return {
        type: UPDATED_STAFF_MEMBER,
        touched: false,
    };
}

export function deletedStaff(staffMember) {
    return {
        type: DELETED_STAFF,
        staffMember,
    };
}

export function fetchedStaffTitles(titles) {
    return {
        type: FETCHED_STAFF_TITLES,
        titles,
    };
}

export function disabledStaff(staffId) {
    return {
        type: DISABLED_STAFF_MEMBER,
        staffId,
    };
}

export function enabledStaff(staffId) {
    return {
        type: ENABLED_STAFF_MEMBER,
        staffId,
    };
}

export function fetchedStaffMember(staffMember) {
    return {
        type: FETCHED_STAFF_MEMBER,
        staffMember,
    };
}

export function fetchedStaffTeams(teams) {
    return {
        type: FETCHED_STAFF_TEAMS,
        teams,
    };
}

export function fetchedProjectsByDestination(projects, destinationId) {
    return {
        type: FETCHED_PROJECTS_BY_DESTINATION,
        payload: {
            projects: projects,
            destinationId: destinationId,
        },
    };
}

export function changeTitle(title) {
    return {
        type: SELECT_STAFF_TITLE,
        title,
        touched: true,
    };
}

export function changeJobs(jobs) {
    return {
        type: SELECT_JOB_TITLES,
        jobs,
        touched: true,
    };
}

export function changeName(name) {
    return {
        type: SELECT_STAFF_NAME,
        name,
        touched: true,
    };
}

export function changeFirstName(firstname) {
    return {
        type: SELECT_STAFF_FIRST_NAME,
        firstname,
        touched: true,
    };
}

export function changeStaffTeams(staffTeams) {
    return {
        type: SELECT_STAFF_TEAMS,
        payload: {
            staffTeams: staffTeams,
            touched: true,
        },
    };
}

export function changeStaffSites(sites) {
    return {
        type: SELECT_STAFF_SITES,
        sites,
        touched: true,
    };
}

export function changeStaffDestinations(destinations) {
    return {
        type: SELECT_STAFF_DESTINATIONS,
        destinations,
        touched: true,
    };
}

export function changeStaffDescription(description) {
    return {
        type: SELECT_STAFF_DESCRIPTION,
        description,
        touched: true,
    };
}

export function projectRemoveForDestination(project) {
    return {
        type: PROJECT_REMOVE_FOR_DESTINATION,
        project,
    };
}

export function projectAddForDestination(project) {
    return {
        type: PROJECT_ADD_FOR_DESTINATION,
        project,
    };
}

export function fetchedStaffTranslations(staffTranslations) {
    return {
        type: FETCHED_STAFF_TRANSLATIONS,
        staffTranslations,
    };
}

export function fetchedStaffTranslation(staffTranslation) {
    return {
        type: FETCHED_STAFF_TRANSLATION,
        staffTranslation,
    };
}

export function createdStaffTranslation(staffTranslation) {
    return {
        type: CREATED_STAFF_TRANSLATION,
        staffTranslation,
        touched: false,
    };
}

export function updatedStaffTranslation(staffTranslation) {
    return {
        type: UPDATED_STAFF_TRANSLATION,
        staffTranslation,
        touched: false,
    };
}

export function deletedStaffTranslation(translationId) {
    return {
        type: DELETED_STAFF_TRANSLATION,
        translationId,
    };
}

export function updateImage(image) {
    return {
        type: ADD_IMAGE,
        payload: image[0],
        touched: true,
    };
}

export function deleteImage() {
    return {
        type: DELETE_IMAGE,
        touched: true,
    };
}

export function updateImageMeta(imageMeta) {
    const {title, alt, name, filename, description, link} = imageMeta;
    let imageMetaUpdated = {
        title,
        alt,
        name:
            name !== undefined ? name : filename !== undefined ? filename : '',
        description,
        link,
    };

    return {
        type: UPDATE_IMAGE_META,
        imageMeta: imageMetaUpdated,
        touched: true,
    };
}

export function updateCroppedImage(image, imageUrlBlob, imageBlobObject) {
    return {
        type: UPDATE_CROPPED_IMAGE,
        payload: {
            image,
            imageUrlBlob,
            imageBlobObject,
            touched: true,
        },
    };
}



// WEBPACK FOOTER //
// ./src/containers/staff/actions.js